import React from 'react';
import HeaderTwo from '../../components/header/HeaderTwo';
import BreadCrumb from './BreadCrumb';
import Footer from '../../components/footer/Footer';
import { Helmet } from 'react-helmet';
import Seo from '../../components/Seo';
import OATTMVideos from './OATTMVideos';


function AiVideo() {
  return (
	<>
	<Helmet>
		<link rel="canonical" href="https://oliverandthetimemachine.com/videos" />
		<title>Oliver and the Time Machine – Videos & Book Trailers</title>
		<meta name="description" content="AI videos from the Oliver and the Time Machine series." />
	</Helmet>
	<Seo 
		title="Oliver and the Time Machine – Videos & Book Trailers"
		description="AI videos from the Oliver and the Time Machine series."
		url="/videos"
	/>
	<HeaderTwo/>
	<BreadCrumb/>
	<main>
	<OATTMVideos/>
	</main>
	<Footer/>
	</>
  )
}

export default AiVideo